export enum RefreshComponentsUrl {
  QC_TASK_LIST_PAGE = '/imagingproject/qc',
  QC_DETAILS_PAGE = '/imagingproject/qc/details',
  UPLOAD_LIST_PAGE = '/imagingproject/upload',
  SIGN_STUDIES_LIST_PAGE = '/sign',
}

export const SIGN_REPORTS_LIST_PAGE = /^\/sign\/\d+$/;
